module.exports = __webpack_public_path__ + "img/turkish_eggs_front.d270a817.jpg";